// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VIXf","placeholdersHeader":"styles_placeholdersHeader__2FqNw","editorStyle":"styles_editorStyle__1qfZR","placeholdersBox":"styles_placeholdersBox__1q8AH"};